<div id="modalGenerico" class="modal d-none" #modal>
    <article>
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        <h1>Algo inesperado ocurrió</h1>
        <p>Tuvimos un inconveniente para terminar el proceso de validación. Intenta nuevamente</p>
        <button class="button" (click)="hide()">Intentar de nuevo</button>
    </article>
</div>

<!-- Elastic Search INFO: -->
<div id="modalInfo" class="modal d-none" #modalInfo>
    <div class="modalContainer">
      <img class="btn-close" src="/assets/images/Cancel.png" alt="close" (click)="hideModalInfo()" >
        <h4 class="title">Elasticsearch</h4>
        <div *ngIf="data" class="info">
          <p *ngFor="let info of data.description">{{ info }}</p>
        </div>
    </div>
</div>
